import React from 'react'

export default function RoomBanner({roomBanner}) {
  return (
    <>
    <section className="roomdetail-image header-gap">
        <img src={roomBanner.image} alt="room" className="img-responsive" />
    </section>
    </>
  )
}
